import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Status from '@/components/request/Status'
import Request from '@/components/request/Request'
import Accord24 from '@/components/associations/Accord24'
import AssociationsList from '@/components/associations/AssociationsList'
import RequestsList from '@/components/request/RequestsList'
import RequestViewer from '@/components/request/RequestViewer'
import PublicRequest from '@/components/request/PublicRequest'
import Association from '@/components/associations/Association'
import Register from '@/components/user/Register'
import Login from '@/components/user/Login'
import Documentation from '@/components/Documentation'
import Welcome from '@/components/Welcome'
import tenant from '@/tenant'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    { path: '/', component: Home },
    { path: '/certificates/:tenantName', component: Request },
    { path: '/certificates/:tenantName/:pinNumber', component: Request },
    { path: '/certificates', component: Request },
    { path: '/status/:requestId', component: Status },
    { path: '/requests/', component: RequestsList, meta: { requiresAuth: true } },
    { path: '/requests/:id', component: RequestViewer, meta: { requiresAuth: true } },
    { path: '/associations/', component: AssociationsList, meta: { requiresAuth: true } },
    { path: '/associations/:id', component: Association, meta: { requiresAuth: true } },
    { path: '/associations/:id/accord', component: Accord24, meta: { requiresAuth: true } },
    { path: '/fillable-certificate-of-property-insurance-form', component: PublicRequest },
    { path: '/register/', component: Register },
    { path: '/documentation/', component: Documentation },
    { path: '/welcome/', component: Welcome },
    { path: '/login/', component: Login }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    tenant.app.auth().onAuthStateChanged((user) => {
      if (user && !user.isAnonymous) {
        next()
      } else {
        let toPath = encodeURIComponent(to.path)
        next('/login?redir=' + toPath)
      }
    })
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js